// components/RequireActiveStudent.tsx
import React from "react";
import { useAuth } from "../../context/AuthContext";
import { FaLock } from "react-icons/fa";
import { Link } from "react-router-dom";

interface RequireActiveStudentProps {
  children: React.ReactNode;
}

const RequireActiveStudent: React.FC<RequireActiveStudentProps> = ({
  children,
}) => {
  const { student } = useAuth();

  // DEBUG: Log the student data (remove this after testing)
  console.log("RequireActiveStudent - Student data:", student);
  console.log(
    "RequireActiveStudent - activeStudent:",
    (student as any)?.activeStudent
  );
  console.log(
    "RequireActiveStudent - isActiveStudent:",
    (student as any)?.isActiveStudent
  );

  if (!student) {
    return <div>Loading...</div>;
  }

  // Check both possible field names to be safe
  const isInactive = !!student && student.isActiveStudent === false;

  if (isInactive) {
    console.log("Student is inactive, showing blocked UI");

    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <FaLock className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Account Inactive
            </h2>
            <p className="text-gray-600 leading-relaxed">
              This section is only available for active students. Please clear
              all dues to reactivate your account and continue your learning
              journey.
            </p>
          </div>

          <div className="space-y-3">
            <Link
              to="/student/my-courses"
              className="block w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              View Payment Options
            </Link>

            <Link
              to="/student/student-dashboard"
              className="block w-full text-gray-500 hover:text-gray-700 transition-colors"
            >
              ← Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    );
  }

  console.log("Student is active, rendering children");
  return <>{children}</>;
};

export default RequireActiveStudent;
